<script setup lang="ts">
import type { State } from '@/store/store_types';
import { computed } from 'vue';
import { useStore } from 'vuex';
import type { Notification } from './notifications.types';

const { notification } = defineProps<{ notification: Notification }>()

const store = useStore<State>()
const users = computed(() => store.state.users)
const trips = computed(() => store.state.trips)

const showAvatar = computed(
  () => notification.category === 'MEMBER' || notification.category === 'TRIP',
)

const avatarSrc = computed<string | undefined>(() => {
  if (notification.category === 'MEMBER') {
    return users.value.find((user) => user.id === notification.user_id)?.avatarURL ?? undefined
  } else if (notification.category === 'TRIP') {
    const trip = trips.value.find((trip) => trip.localId === notification.linked_trip)
    return trip ? undefined : undefined
    // TODO: Once trip assignment is done, replace with actual trip-related assigner avatar or icon
  }
  return undefined
})

const icon = computed(() => {
  switch (notification.category) {
    case 'VEHICLE':
      return 'custom:carKeyOutlined'
    default:
      return 'mdi-bell'
  }
})

const showAppend = computed(() => notification.category === 'TRIP')

</script>
<template>
  <v-list-item
    class="mb-3 rounded-lg bg-pwt_off_white pa-5"
  >
    <!-- prepend: avatar -->
    <template v-if="showAvatar" v-slot:prepend>
      <v-avatar class="mr-3 mt-1">
        <img v-if="avatarSrc" :src="avatarSrc"  width="100%" height="auto"/>
        <v-icon v-else icon="custom:avatar" size="100%" />
      </v-avatar>
    </template>

    <!-- prepend: icon -->
    <template v-else v-slot:prepend>
      <v-icon :icon="icon" color="primary" size="36" />
    </template>

    <!-- content -->
    <v-list-item-title>{{ notification.title }}</v-list-item-title>
    <v-list-item-subtitle>{{ notification.message }}</v-list-item-subtitle>

    <!-- append -->
  </v-list-item>
</template>
